import { DEFAULT_LOCALE, type UserReturnDto } from '@skillarea/lib-shared';
import 'reflect-metadata';
import { type DefaultOptions, QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

import './stores/_init';

const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: 1000 * 60 * 5,
    retry: 1,
  },
} as const;

export function getRouter() {
  const queryClient = new QueryClient({ defaultOptions });
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    context: {
      queryClient,
      user: null as UserReturnDto | null,
      locale: DEFAULT_LOCALE,
    },
  });
  return router;
}

export type TAppRouter = ReturnType<typeof getRouter>;

declare module '@tanstack/react-router' {
  interface IRegister {
    router: TAppRouter;
  }
}
